// NPM Imports
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip, Toastr } from "@revvsales/components";
import PropTypes from "prop-types";
import queryString from "query-string";
import { withRouter } from "react-router-dom";

// Components Imports
import withRbac from "../../app/withRbac";
import { RevvSidePanel } from "../../commonComponents";
import CloneTemplatePopup from "../DocTemplates/CloneTemplatePopup";
import CustomRevvToolbar from "../CustomRevvToolbar";
import Outline from "./Outline";
import OnboardingModal from "./OnboardModal";
import ImageFormFieldSidePanel from "./ImageFormFieldSidePanel";
import DocForm from "./DocForm";
import DocumentView from "./DocumentView";
import ClauseOptions from "./ClauseOptions";
import { AcceptanceStatusBand, DocumentStatusBand } from "./StatusBands/index";

// Internal Imports
import { PERMISSIONS, DOCUMENTS, EVENTS } from "../../constants";
import { DOCUMENT_MODE } from "../../constants/document";
import { DOCUMENTVIEW_MODE } from "./constants";
import {
  onBoardingContent,
  onBoardingTypes,
  onBoardingModals,
} from "./OnboardModal/options";
import { GlobalUtils, AmplitudeUtils } from "../../utils";

// Actions Imports
import { QuotationActions } from "../../actions";
import {
  setCommonHash,
  setMetalensTutorialActiveStatus,
} from "../../actions/MetalensActions/metalensActions";
import { setOnboardingModalStatus } from "../../actions/OnboardingModalActions/onBoardingModalActions";
import QuickReviewIcon from "../QuickReview/QuickReviewIcon";

const { updateToolPaneData } = QuotationActions;

const {
  DOCUMENT_COMPONENT_TYPES,
  DOCUMENT_ZOOM_CONFIGS,
  DOCUMENT_BG_COLORS,
  DOCUMENT_BG_PATTERNS,
  DOCUMENT_DEFAULT_BG_COLOR,
} = DOCUMENTS;
const { EVENT_NAMES } = EVENTS;
const { FORMVIEW, DOCUMENTVIEW } = DOCUMENTVIEW_MODE;
const { readDataFromLocalStorage } = GlobalUtils;
const { amplitudeLogEvent } = AmplitudeUtils;

class DocumentV2 extends Component {
  docHeaderRef = React.createRef();

  docFooterRef = React.createRef();

  docDeletePopupRef = React.createRef();

  customToolbarRef = React.createRef();

  docBgColorDropdownRef = React.createRef();

  metalensDropdownRef = React.createRef();

  metalensIconRef = React.createRef();

  toolbarCustomColorDropdownRef = React.createRef();

  tableColorpickerDropdownRef = React.createRef();

  constructor(props) {
    super(props);
    let savedBgColor = null;
    // let savedZoom = null;
    if (props.metaData) {
      savedBgColor = props.metaData.documentBgColor;
      // savedZoom = props.metaData.zoomSetting;
    }

    this.state = {
      showCloneTemplatePopup: false,
      zoomSetting: DOCUMENT_ZOOM_CONFIGS["100"],
      currentView: props.showForm ? FORMVIEW : DOCUMENTVIEW,
      documentBgColor: savedBgColor || DOCUMENT_DEFAULT_BG_COLOR,
      showDocBgColorDropdown: false,
      showMetalensDropdown: false,
      formCanRender: false,
      onBoardingType: "esignature",
      onBoardingSource: "",
      formOpen: true,
    };
  }

  componentDidMount() {
    const metalensData = readDataFromLocalStorage("metalensData");
    if (!metalensData || !(metalensData && metalensData.newTutorialSet)) {
      this.props.setMetalensTutorialActiveStatus(true);
    }

    const onBoardingData = readDataFromLocalStorage("onBoardingData");
    let source = this._getOnboardingInfo();
    source = source.toLowerCase();
    let canShow = false;
    if (onBoardingTypes.indexOf(source) < 0) {
      source = "esignature";
    }
    if (!onBoardingData) {
      canShow = true;
    } else if (
      typeof onBoardingData[source] === "undefined" ||
      onBoardingData[source]
    ) {
      canShow = true;
    }

    if (canShow) {
      const obt = this._getOnboardingBySource(source);
      this.setState({ onBoardingType: obt, onBoardingSource: source });
      this.props.setOnboardingModalStatus(true);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isLocked !== this.props.isLocked) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ formOpen: !this.props.isLocked });
    }

    if (
      (!prevProps.isToolpaneOpen ||
        prevProps.toolpaneView !== "quick-review") &&
      this.props.isToolpaneOpen &&
      this.props.toolpaneView === "quick-review"
    ) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ formOpen: false });
    }
  }

  componentWillUnmount() {
    this.props.setCommonHash();
    document.removeEventListener("keydown", this._keyDownHandler);
  }

  _getOnboardingInfo = () => {
    const signUpInfo = readDataFromLocalStorage("userSignUpInfo");
    const url = signUpInfo && signUpInfo.c_utm ? signUpInfo.c_utm : "";
    const queryParams = queryString.parse(url.split("?")[1]);
    const paramKeys = Object.keys(queryParams);
    if (paramKeys.includes("utm_campaign") && queryParams.utm_campaign) {
      return queryParams.utm_campaign;
    }
    return "";
  };

  _getOnboardingBySource = source => {
    const model = onBoardingModals[source];
    return Array.isArray(model)
      ? model[Math.floor(Math.random() * model.length)]
      : model;
  };

  _startFormRender = () => {
    this.setState({ formCanRender: true });
  };

  _setRefsByType = (type, element) => {
    if (type === "DOCUMENT_SECTION") {
      this.documentSecRef = element;
    }
  };

  _setDraggedSection = (section, draggedFrom) => {
    this.props.setDraggedSection(section, draggedFrom);
  };

  _removeComponent = (sectionID, section) => {
    this.props.deleteComponent(sectionID, section);
  };

  _updateComponentLabel = (sectionID, label) => {
    this.props.updateComponentLabel(sectionID, label);
  };

  _toggleDocumentDiffView = () => {
    this.props.toggleDocumentDiffView();
  };

  _toggleFormView = () => {
    if (this.props.showOutlineView) {
      this.props.toggleOutlineView();
    }

    if (
      this.props.isToolpaneOpen &&
      this.props.addComponentType !== "Signature" &&
      this.props.view !== "doc-components" &&
      this.props.showForm &&
      !this.state.formOpen
    ) {
      this.props.updateToolPaneData(false, "");
    }
    this.setState(prevState => ({
      formOpen: !prevState.formOpen,
    }));
  };

  _resetComponentType = e => {
    const docHeaderNode = this.docHeaderRef.current;
    const docFooterNode = this.docFooterRef.current;
    const docDeletePopupNode = this.docDeletePopupRef.current;
    // ignore clicks on the component itself
    if (
      (docHeaderNode && docHeaderNode.contains(e.target)) ||
      (docFooterNode && docFooterNode.contains(e.target)) ||
      (docDeletePopupNode && docDeletePopupNode.contains(e.target))
    ) {
      return;
    }

    if (
      this.props.addComponentType === DOCUMENT_COMPONENT_TYPES.HEADER_FOOTER
    ) {
      this.props.updateAddComponentinToolbarAction(null);
      this.props.updateDocumentClickedComponentID(null, true, null);
    }
  };

  _decideDocumentView = () => {
    const disableEdit = this.props.isLocked || this.props.isSharedDocument;
    return (
      <div
        className="document-sections"
        data-test="documentview-document-sections">
        {
          <DocumentView
            show
            showForm={this.props.showForm}
            match={this.props.match}
            startFormRender={this._startFormRender}
            currentView={this.props.currentView}
            switchView={this._switchView}
            docID={this.props.docID}
            mode={this.props.mode}
            layout={this.props.layout}
            components={this.props.components}
            isLocked={
              disableEdit ||
              this.props.showDocumentDiffView ||
              this.props.showForm
            }
            isSharedDocument={this.props.isSharedDocument}
            isDocumentLocked={this.props.isDocumentLocked}
            draggedSection={this.props.draggedSection}
            // setDraggedSection={this.props.setDraggedSection}
            addComponentType={this.props.addComponentType}
            addComponent={this.props.addComponent}
            updateComponent={this.props.updateComponent}
            deleteComponent={this.props.deleteComponent}
            removeActiveComponents={this._removeActiveComponents}
            isTemplateTypeForm={this.props.isTemplateTypeForm}
            showDocumentDiffView={this.props.showDocumentDiffView}
            removeHighlightSelection={this.props.removeHighlightSelection}
            updateHoveredSectionId={this.props.updateHoveredSectionId}
            // Hovered and Clicked active component id's related props
            clickedActiveComponentId={this.props.clickedActiveComponentType}
            clickedActiveComponentType={this.props.clickedActiveComponentType}
            preventClickedComponentIdUpdate={
              this.props.preventClickedComponentIdUpdate
            }
            hoveredActiveComponentId={this.props.hoveredActiveComponentId}
            updateDocumentClickedComponentID={
              this.props.updateDocumentClickedComponentID
            }
            setSectionDataForActiveSignatureInRightToolPane={
              this.props.setSectionDataForActiveSignatureInRightToolPane
            }
            // Refs related props
            docHeaderRef={this.docHeaderRef}
            docFooterRef={this.docFooterRef}
            docDeletePopupRef={this.docDeletePopupRef}
            customToolbarRef={this.customToolbarRef}
            toolbarCustomColorDropdownRef={this.toolbarCustomColorDropdownRef}
            signatureWrapperRef={this.props.signatureWrapperRef}
            setRefsByType={this._setRefsByType}
            updateAddComponentinToolbarAction={
              this.props.updateAddComponentinToolbarAction
            }
            updateToolPaneData={this.props.updateToolPaneData}
            coverpageThemeAction={this.props.coverpageThemeAction}
            changeToolsView={this.props.changeToolsView}
            setSectionDataForActivePaymentButtonInRightToolPane={
              this.props.setSectionDataForActivePaymentButtonInRightToolPane
            }
            tableColorpickerDropdownRef={this.tableColorpickerDropdownRef}
          />
        }
      </div>
    );
  };

  _getToolbarView = () =>
    !this.props.isLocked &&
    !this.props.isSharedDocument &&
    !this.props.showForm ? (
      <CustomRevvToolbar
        mode={this.props.mode}
        docID={this.props.docID} // Used for add Note
        removeHighlightSelection={this.props.removeHighlightSelection}
        updateSection={this.props.updateComponent} // Used for add Note and add Hyperlink
        customToolbarRef={this.customToolbarRef}
        toolbarCustomColorDropdownRef={this.toolbarCustomColorDropdownRef}
        handleUndo={this.props.reactionsOnUndoClick} // Used only for CustomText and CustomTableText Editor
        handleRedo={this.props.reactionsOnRedoClick}
        isSeparateToolbar
      />
    ) : null;

  _getDiffModeMessage = () =>
    this.props.mode === DOCUMENT_MODE.DOCUMENT &&
    !this.props.showForm &&
    this.props.showDocumentDiffView ? (
      <div className="document-diffmode-message">
        <FontAwesomeIcon
          icon={["far", "info-circle"]}
          className="document-diffmode-messageicon"
        />
        {this.props.docStage === "DRAFT"
          ? "This is a view only mode, toggle off diff mode to edit this document."
          : "This is redline view, toggle off preview redlines for normal view "}
      </div>
    ) : null;

  _getSwitchViewBtn = () => {
    const CloneTemplateBtn = withRbac(() => (
      <div className="document-clone-tamplate-wrapper">
        <div
          data-test="document-customizethistemplate-button"
          className="document-clone-tamplate-btn"
          onClick={this._openCloneTemplatePopup}
          onKeyPress={() => {}}
          role="button"
          tabIndex="0">
          <span className="document-clone-tamplate-icon">
            <FontAwesomeIcon icon={["far", "clone"]} />
          </span>
          Customize this template
        </div>
      </div>
    ));

    return this.props.mode === DOCUMENT_MODE.DOCUMENT && this.props.showForm ? (
      <div className="doc-form-switch">
        {this._allowtemplateClone() && (
          <CloneTemplateBtn
            permission={PERMISSIONS.TEMPLATES.UPDATE_TEMPLATES}
          />
        )}
      </div>
    ) : null;
  };

  _allowtemplateClone = () =>
    this.props.mode === DOCUMENT_MODE.DOCUMENT &&
    !this.props.isSharedDocument &&
    this.props.docTemplateId;

  _handleZoomIn = event => {
    event.preventDefault();
    event.stopPropagation();
    const { zoomSetting } = this.state;
    if (zoomSetting && zoomSetting.next) {
      const newZoom = DOCUMENT_ZOOM_CONFIGS[zoomSetting.next];
      this.setState({ zoomSetting: newZoom });
    }
  };

  _handleZoomOut = event => {
    event.preventDefault();
    event.stopPropagation();
    const { zoomSetting } = this.state;
    if (zoomSetting && zoomSetting.prev) {
      const newZoom = DOCUMENT_ZOOM_CONFIGS[zoomSetting.prev];
      this.setState({ zoomSetting: newZoom });
    }
  };

  _changeDocumentBgColor = (event, color) => {
    event.preventDefault();
    event.stopPropagation();
    const currentBGColor = this.state.documentBgColor;
    this.setState({
      documentBgColor: color,
    });
    this._updateDocMeta("documentBgColor", color, currentBGColor);
  };

  _updateDocMeta = (key, value, prevValue) => {
    const data = [
      {
        op: "replace",
        field: "meta_data",
        value: { meta_data: { ...this.props.metaData, [key]: value } },
      },
    ];
    if (this.props.mode === DOCUMENT_MODE.DOCUMENT) {
      this.props
        .updateDocMeta({ docId: this.props.docID, data })
        .then()
        .catch(() => {
          Toastr.showToastr({
            type: "failure",
            message: "Oops, Something went wrong!!",
            timeout: 3000,
          });
          this.setState({
            [key]: prevValue,
          });
        });
    } else if (this.props.mode === DOCUMENT_MODE.TEMPLATE) {
      this.props
        .updateTemplateMeta({ docId: this.props.docID, data })
        .then()
        .catch(() => {
          Toastr.showToastr({
            type: "failure",
            message: "Oops, Something went wrong!!",
            timeout: 3000,
          });
          this.setState({
            [key]: prevValue,
          });
        });
    }
  };

  _toggleDocBgColorDropdown = event => {
    if (event) {
      event.stopPropagation();
    }
    // attach/remove event handler
    if (!this.state.showDocBgColorDropdown) {
      document.addEventListener(
        "click",
        this._handleDocBgColorDropdownOutsideClick,
        false,
      );
    } else {
      document.removeEventListener(
        "click",
        this._handleDocBgColorDropdownOutsideClick,
        false,
      );
    }
    this.setState(prevState => ({
      showDocBgColorDropdown: !prevState.showDocBgColorDropdown,
    }));
  };

  _handleDocBgColorDropdownOutsideClick = e => {
    const node = this.docBgColorDropdownRef.current;
    // ignore clicks on the component itself
    if (node && node.contains(e.target)) {
      return;
    }
    this._toggleDocBgColorDropdown();
  };

  _handleMetalensDropdownOutsideClick = e => {
    const node = this.metalensDropdownRef.current;
    if (
      (node && node.contains(e.target)) ||
      e.target.dataset.belongsto === "metalens-dropdown"
    ) {
      return;
    }
    this._toggleMetalensDropdown();
  };

  _toggleMetalensDropdown = event => {
    let InitiatedFrom = "document";
    if (event) {
      if (
        event.target &&
        event.target.dataset &&
        event.target.dataset.from &&
        event.target.dataset.from === "metalens-tutorial"
      ) {
        InitiatedFrom = "popup";
      }
      event.stopPropagation();
    }
    // attach/remove event handler
    if (!this.state.showMetalensDropdown) {
      document.addEventListener(
        "click",
        this._handleMetalensDropdownOutsideClick,
        false,
      );
    } else {
      document.removeEventListener(
        "click",
        this._handleMetalensDropdownOutsideClick,
        false,
      );
    }
    this.setState(
      prevState => ({
        showMetalensDropdown: !prevState.showMetalensDropdown,
      }),
      () => {
        if (this.state.showMetalensDropdown) {
          // call amplitude
          amplitudeLogEvent(EVENT_NAMES.METALENS_ACTIVE, {
            InitiatedFrom,
            DocID: this.props.docID,
          });
        }
      },
    );
  };

  _toggleQuickReview = event => {
    let InitiatedFrom = "document";
    if (event) {
      if (
        event.target &&
        event.target.dataset &&
        event.target.dataset.from &&
        event.target.dataset.from === "metalens-tutorial"
      ) {
        InitiatedFrom = "popup";
      }
      event.stopPropagation();
    }
    const { toolpaneView, isToolpaneOpen } = this.props;
    if (toolpaneView === "quick-review" && isToolpaneOpen) {
      this.props.updateToolPaneData(false, "");
    } else {
      this.props.updateToolPaneData(true, "quick-review");
      // close form if open
      this.setState({ formOpen: false });
      // call amplitude
      amplitudeLogEvent(EVENT_NAMES.METALENS_ACTIVE, {
        InitiatedFrom,
        DocID: this.props.docID,
      });
    }
  };

  render() {
    const { showCloneTemplatePopup } = this.state;

    let editable = false;
    if (
      !(
        this.props.isLocked ||
        this.props.isDocumentLocked ||
        this.props.isSharedDocument ||
        (this.props.isTemplateTypeForm && this.props.showForm)
      )
    ) {
      editable = true;
    }

    const CloneTemplateBtn = withRbac(() => (
      <div className="document-clone-tamplate-wrapper">
        <div
          data-test="document-customizethistemplate-button"
          className="document-clone-tamplate-btn"
          onClick={this._openCloneTemplatePopup}
          onKeyPress={() => {}}
          role="button"
          tabIndex="0">
          <span className="document-clone-tamplate-icon">
            <FontAwesomeIcon icon={["far", "clone"]} />
          </span>
          Customize this template
        </div>
      </div>
    ));

    let zoomClassName = "";
    let disableZoomInBtn = "";
    let disableZoomOutBtn = "";
    if (this.state.zoomSetting) {
      zoomClassName = `zoom-${this.state.zoomSetting.current}`;
      if (!this.state.zoomSetting.prev) {
        disableZoomOutBtn = "disable-zoom-button";
      } else if (!this.state.zoomSetting.next) {
        disableZoomInBtn = "disable-zoom-button";
      }
    }

    return (
      <Fragment>
        {showCloneTemplatePopup && (
          <CloneTemplatePopup
            closePopup={this._closeCloneTemplatePopup}
            id={this.props.docTemplateId}
            docName={this.props.docName}
          />
        )}
        <div
          className={`${
            this.props.className
          }  document-wrapper scrollable-container ${zoomClassName} ${
            this.state.documentBgColor
          }`}
          data-test="document-wrapper">
          {/* -------------- CustomRevvToolbar Section -------------- */}
          {/**
           * ::===:: CustomRevvToolbar (or Separate Toolbar) ::===::
           * It is being used here only for the scenarios where Editor and Toolbar both come separately
           * (ex: CustomText and CustomTableText Editor)
           */}
          {this._getToolbarView()}
          <div data-test="document-wrapper" className="document-container">
            {/* -------------- canvas bg color -------------- */}
            <div
              className={`canvas-options animated slideinright ${
                this.state.showDocBgColorDropdown ? "dd-open" : ""
              }`}>
              {/* -------------- Meta Lens Section-------------- */}
              {this.props.mode === DOCUMENT_MODE.DOCUMENT &&
                !this.props.isSharedDocumentPerma &&
                this.props.isSharedDocument && (
                  <div className="canvas-metalens-wrapper">
                    <div className="canvas-metalens-dropdown">
                      <Tooltip
                        placement="left"
                        overlayClassName="metalens-tooltip"
                        overlay="Metalens identifies and highlights data in the document such as names, dates, amounts, and more">
                        <div
                          className="metalens-icon-shine"
                          onClick={this._toggleQuickReview}
                          data-belongsto="metalens-dropdown"
                          onKeyPress={() => {}}
                          ref={this.metalensIconRef}
                          role="button"
                          tabIndex="0">
                          <QuickReviewIcon
                            active={
                              this.props.isToolpaneOpen &&
                              this.props.toolpaneView === "quick-review"
                            }
                          />
                        </div>
                      </Tooltip>
                    </div>
                  </div>
                )}
              {!this.props.isSharedDocument &&
                this.props.mode === DOCUMENT_MODE.DOCUMENT && (
                  <OnboardingModal
                    isOpen={this.props.onBoardingModal}
                    toggleModal={this.props.setOnboardingModalStatus}
                    toggleDropdown={
                      onBoardingContent[`${this.state.onBoardingType}`]
                        .hasToggle
                        ? this._toggleQuickReview
                        : null
                    }
                    dataObject={
                      onBoardingContent[`${this.state.onBoardingType}`]
                    }
                    onBoardingSource={this.state.onBoardingSource}
                  />
                )}
              {/* -------------- Canvas background color section-------------- */}
              {!this.props.isLocked && (
                <div className="canvas-bg-wrapper">
                  <div className="canvas-bg-dropdown">
                    <Tooltip
                      placement="left"
                      align={{
                        offset: [0, 4],
                      }}
                      overlay="Canvas Background">
                      <div
                        className={`canvas-bg-color ${
                          this.state.documentBgColor
                        } `}
                        onClick={this._toggleDocBgColorDropdown}
                        onKeyPress={() => {}}
                        role="button"
                        tabIndex="0">
                        <i>
                          <FontAwesomeIcon icon={["far", "fill-drip"]} />
                        </i>
                      </div>
                    </Tooltip>
                    {this.state.showDocBgColorDropdown && (
                      <div
                        className="canvas-dropdown"
                        ref={this.docBgColorDropdownRef}>
                        <div className="canvas-colors-wrapper">
                          <div className="canvas-colors-title">
                            Solid colors
                          </div>
                          {DOCUMENT_BG_COLORS.map(color => (
                            <div
                              className={`canvas-colors ${
                                this.state.documentBgColor === color
                                  ? " active "
                                  : ""
                              } ${color}`}
                              onClick={event =>
                                this._changeDocumentBgColor(event, color)
                              }
                              onKeyPress={() => {}}
                              role="button"
                              tabIndex="0"
                            />
                          ))}
                          <div className="canvas-colors-title">Patterns</div>
                          {DOCUMENT_BG_PATTERNS.map(color => (
                            <div
                              className={`canvas-colors ${
                                this.state.documentBgColor === color
                                  ? " active "
                                  : ""
                              } ${color}`}
                              onClick={event =>
                                this._changeDocumentBgColor(event, color)
                              }
                              onKeyPress={() => {}}
                              role="button"
                              tabIndex="0"
                            />
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
              <div className="zoom-options" data-test="zoom-options">
                <div
                  className={`btn-zoom-in ${disableZoomInBtn}`}
                  onClick={e => this._handleZoomIn(e)}
                  onKeyPress={() => {}}
                  role="button"
                  tabIndex="0">
                  {" "}
                  <FontAwesomeIcon icon={["far", "plus"]} />
                </div>
                <div className="zoom-count">
                  {/* zoom % 50,65,75,80,90,100,110,125,150 */}
                  <span>
                    {this.state.zoomSetting
                      ? `${this.state.zoomSetting.current}%`
                      : null}
                  </span>
                </div>
                <div
                  className={`btn-zoom-out ${disableZoomOutBtn}`}
                  onClick={e => this._handleZoomOut(e)}
                  onKeyPress={() => {}}
                  role="button"
                  tabIndex="0">
                  {" "}
                  <FontAwesomeIcon icon={["far", "minus"]} />
                </div>
              </div>
            </div>

            {/* -------------- Document Left Section (Outline View) -------------- */}
            <Outline
              editable={editable}
              mode={this.props.mode}
              docForm={this.props.docForm}
              isLocked={this.props.isLocked}
              isFormOpen={this.state.formOpen}
              currentView={this.state.currentView}
              showOutlineView={this.props.showOutlineView}
              toggleOutlineView={this.props.toggleOutlineView}
              updateOutlineLabel={
                this.props.updateOutlineLabel // Used for add Note and add Hyperlink
              }
              isSharedDocument={this.props.isSharedDocument}
              coverpageIsVisible={this.props.coverpageIsVisible}
              headerfooterIsVisible={this.props.headerfooterIsVisible}
              formView={this._toggleFormView}
            />
            <DocForm
              {...this.props}
              currentView={this.state.currentView}
              formOpen={this.state.formOpen}
              switchView={this._switchView}
              toggleFormView={this._toggleFormView}
              sharingHash={this.props.sharingHash}
              isSharedDocument={this.props.isSharedDocument}
              docID={this.props.docID}
              formCanRender={this.state.formCanRender}
            />
            {/* -------------- Document Middle Section -------------- */}
            <div
              data-test="document-sections-wrapper"
              className={`document-sections-wrapper ${
                this.props.isToolpaneOpen ? "is-open" : ""
              } ${
                this.state.formOpen &&
                this.props.showForm &&
                this.props.recipientType !== "ACCEPTOR" &&
                this.props.recipientType !== "REVIEWER"
                  ? "form-open add-left-margin"
                  : "form-close"
              } ${
                this.props.isSharedDocument
                  ? "shareddocument-sections-wrapper"
                  : ""
              } ${!this.props.showOutlineView ? "outline-hidden" : ""}`}
              id="document-sections-wrapper"
              onClick={this._resetComponentType}
              onKeyPress={() => {}}
              role="button"
              tabIndex="0">
              {/* Document diff mode messgae */}
              {this._getDiffModeMessage()}
              {this._getSwitchViewBtn()}
              {/* Clone Template Button */}
              {this._allowtemplateClone() && !this.props.showForm && (
                <CloneTemplateBtn
                  permission={PERMISSIONS.TEMPLATES.UPDATE_TEMPLATES}
                />
              )}
              {<DocumentStatusBand {...this.props} />}
              {<AcceptanceStatusBand {...this.props} />}
              <div
                className={`document-view-wrapper ${
                  !this.state.formOpen &&
                  this.props.showForm &&
                  !this.props.showOutlineView
                    ? "make-doc-center"
                    : ""
                }`}>
                {this._decideDocumentView()}
              </div>
            </div>
            {/* --------- Add Clause Option SideBar Section --------- */}
            {this.props.mode === DOCUMENT_MODE.TEMPLATE &&
              this.props.openClauseOptions &&
              !this.props.isLocked && (
                <div className="document-clause-options-pane">
                  <ClauseOptions updateComponent={this.props.updateComponent} />
                </div>
              )}

            {this.props.mode === DOCUMENT_MODE.TEMPLATE &&
              this.props.isImageFieldSidePanelOpen &&
              !this.props.isLocked && (
                <RevvSidePanel className="" placement="right">
                  <ImageFormFieldSidePanel
                    updateComponent={this.props.updateComponent}
                  />
                </RevvSidePanel>
              )}
          </div>
        </div>
      </Fragment>
    );
  }
}

DocumentV2.propTypes = {
  className: PropTypes.string, // to apply certain class name if required
  docID: PropTypes.string.isRequired,
  mode: PropTypes.string,
  isToolpaneOpen: PropTypes.bool,
  showOutlineView: PropTypes.bool,
  isLocked: PropTypes.bool, // flag to decide if the outline list is visible
  showForm: PropTypes.bool,
  docStage: PropTypes.string,
  isSharedDocument: PropTypes.bool,
  isTemplateTypeForm: PropTypes.bool,
  layout: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)).isRequired,
  toggleOutlineView: PropTypes.func.isRequired, // method to hide/unhide teh outline list
  currentView: PropTypes.string.isRequired, // formview or document view
  formFields: PropTypes.arrayOf(PropTypes.string).isRequired, // list of all the form fields
  components: PropTypes.shape.isRequired, // dict of all the comnponents
  coverpageIsVisible: PropTypes.bool.isRequired, // to check if the coverpage is visible or not
  headerfooterIsVisible: PropTypes.bool, // to check if the header&footer is visible or not
  updateDocMeta: PropTypes.func,
  reactionsOnUndoClick: PropTypes.func,
  reactionsOnRedoClick: PropTypes.func,
  // draggedFrom: PropTypes.string,
  // setDraggedSection: PropTypes.func,
  addComponent: PropTypes.func,
  deleteComponent: PropTypes.func,
  updateComponent: PropTypes.func,
  updateComponentLabel: PropTypes.func,
  toggleDocumentDiffView: PropTypes.func,
  currentMetalensHash: PropTypes.string,
  previousMetalensHash: PropTypes.string,
  setMetalensTutorialActiveStatus: PropTypes.func.isRequired,
};

DocumentV2.defaultProps = {
  className: "",
  mode: DOCUMENT_MODE.DOCUMENT,
  isLocked: false,
  showForm: false,
  docStage: "",
  isSharedDocument: false,
  headerfooterIsVisible: true,
  isTemplateTypeForm: false,
  reactionsOnUndoClick: () => {},
  reactionsOnRedoClick: () => {},
  updateDocMeta: () => {},
  // setDraggedSection: () => {},
  deleteComponent: () => {},
  addComponent: () => {},
  updateComponent: () => {},
  updateComponentLabel: () => {},
  toggleDocumentDiffView: () => {},
  // draggedFrom: "",
  isToolpaneOpen: false,
  showOutlineView: false,
  currentMetalensHash: "",
  previousMetalensHash: "",
};

const mapStateToProps = state => {
  let { docForm = [] } = state.DocumentStore;
  const {
    currentHash: currentMetalensHash,
    previousHash: previousMetalensHash,
    metalensTutorialActive,
  } = state.MetalensStore;
  const { onBoardingModal } = state.OnboardingModalStore;
  const {
    components = {},
    document: { stage } = {},
    docApprovalStatus,
    docRecipientList,
    acceptorsList,
    pendingApprovalRequired,
  } = state.DocumentStore;

  // For Image form field side panel
  const {
    imageFormField: { isOpen: isImageFieldSidePanelOpen },
  } = state.TemplateStore;

  const { acceptingStates, recipientType } = state.SharedDocument;
  const { isOpen: isToolpaneOpen, view: toolpaneView } = state.ToolPaneStore;

  const coverpageId =
    components &&
    Object.keys(components).find(
      componentId =>
        components[componentId] &&
        components[componentId].content &&
        components[componentId].content.type ===
          DOCUMENT_COMPONENT_TYPES.COVERPAGE,
    );

  if (coverpageId) {
    const coverpage = components[coverpageId].content;
    if (
      coverpage.data &&
      coverpage.data.attributes &&
      !coverpage.data.attributes.isOpen &&
      Array.isArray(coverpage.form_field) &&
      coverpage.form_field.length > 0
    ) {
      const cpFieldIds = [];
      coverpage.form_field.forEach(item => cpFieldIds.push(item.id[0]));
      docForm.forEach(item => {
        item.occurrences = item.occurrences.filter(
          id => !cpFieldIds.includes(id),
        );
      });
    }
  }

  // get signature data
  const signatureIds =
    components &&
    Object.keys(components).filter(
      componentId =>
        components[componentId] &&
        components[componentId].content &&
        components[componentId].content.type ===
          DOCUMENT_COMPONENT_TYPES.EMPTY_SIGNATURE_CONTAINER,
    );
  const signatureData = [];
  if (signatureIds) {
    Object.keys(signatureIds).forEach(componentId => {
      if (components[componentId]) {
        const component = components[componentId].content;
        signatureData.push({ sectionID: component.id, mode: "DOCUMENT" });
      }
    });
  }

  docForm = docForm.filter(
    item => Array.isArray(item.occurrences) && item.occurrences.length > 0,
  );

  const { document: { paymentStatus } = {} } = state.DocumentStore;

  return {
    docForm,
    signatureData,
    stage,
    docApprovalStatus,
    docRecipientList,
    acceptorsList,
    pendingApprovalRequired,
    acceptingStates,
    recipientType,
    paymentStatus,
    currentMetalensHash,
    previousMetalensHash,
    metalensTutorialActive,
    isToolpaneOpen,
    toolpaneView,
    onBoardingModal,
    isImageFieldSidePanelOpen,
  };
};

const mapDispatchToProps = {
  updateToolPaneData,
  setCommonHash,
  setMetalensTutorialActiveStatus,
  setOnboardingModalStatus,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(DocumentV2),
);



// WEBPACK FOOTER //
// ./src/components/DocumentV2/DocumentV2.js